// Shim for dev server — moment is loaded globally via Rails <script> tag.
// In production build, moment is excluded via rollupOptions.external.
// TODO: Remove once we move Fullcalendar to V6 (no moment dependency)
export default window.moment;
